import { Link } from 'react-router-dom'
import styled from 'styled-components'

import * as OplevaltContext from './context'
import { txt } from '../../../locales/i18n'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCompassDrafting, faPersonSnowmobiling } from '@fortawesome/pro-duotone-svg-icons'

export { ExperiencePage } from './experiences/experience'
export { ExperiencesPage } from './experiences/experiences'

export { CmsPages } from './cms/pages'
export { CmsPage } from './cms/page'

export const OplevAltPage = () => {
	return (
		<MainStyled>
			<section>
				<h1>Oplev Alt</h1>

				<div className="card-container">
					<Link to="oplevalt/experiences" className="card">
						<FontAwesomeIcon icon={faPersonSnowmobiling} size="4x" />
						<span>{txt('oplevalt.experiences')}</span>
					</Link>

					<Link to="oplevalt/cms" className="card">
						<FontAwesomeIcon icon={faCompassDrafting} size="4x" />
						<span>cms</span>
					</Link>
				</div>
			</section>
		</MainStyled>
	)
}

const MainStyled = styled.main`
	background-color: ${OplevaltContext.theme.orange.neutral};
	padding: 2rem;

	display: flex;
	justify-content: center;

	h1 {
		color: ${OplevaltContext.theme.orange.vibrant};
	}

	section {
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.card-container {
		display: flex;
		flex-direction: row;
		justify-content: center;
		gap: 1rem;
		flex-wrap: wrap;
	}

	.card {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: 1rem;

		padding: 1rem 2rem;
		background-color: white;
		border-radius: 1rem;
		box-shadow: 0 1rem 2rem ${OplevaltContext.theme.orange.vibrant}22;
		color: ${OplevaltContext.theme.orange.vibrant};
		min-width: 240px;

		transition: all 350ms;

		span {
			font-size: 1.4rem;
			text-transform: uppercase;
			color: ${OplevaltContext.theme.orange.vibrant};
		}

		&:hover {
			color: white;
			background-color: ${OplevaltContext.theme.orange.vibrant};

			span {
				color: white;
			}
		}
	}
`
